module.exports = __webpack_public_path__ + "static/media/pw-rating-icon.0f82f849.svg";